import React, { Fragment } from "react";
import { Table } from "react-bootstrap";
import NoDataFound from "../NoDataFound";
import {
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";

interface TableContainerSimpleProps<TData = any> {
  columns: any[];
  data: TData[];
  isBordered?: boolean;
}

const TableContainerSimple = ({
  columns,
  data,
  isBordered = false,
}: TableContainerSimpleProps) => {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  const { getHeaderGroups, getRowModel } = table;

  return (
    <Fragment>
      <div className="table-responsive table-card">
        <Table
          className={`table table-centered align-middle table-custom-effect table-nowrap mt-3  ${
            isBordered ? "table-bordered" : ""
          }`}
          bordered={isBordered}
        >
          {/* HEADER */}
          <thead className="table-light">
            {getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th key={header.id} className="align-middle text-center">
                    {!header.isPlaceholder &&
                      flexRender(header.column.columnDef.header, header.getContext())}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          {/* BODY */}
          <tbody>
            {getRowModel().rows.length === 0 ? (
              <NoDataFound colSpan={columns.length} />
            ) : (
              getRowModel().rows.map((row) => (
                <tr key={row.id}>
                  {row.getVisibleCells().map((cell) => (
                    <td
                      key={cell.id}
                      className="text-center"
                      style={{
                        maxWidth: cell.column.columnDef.maxSize ?? "none",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
    </Fragment>
  );
};

export default TableContainerSimple;
